import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { properties } from '../../../../environments/properties';


@Component({
    selector: 'app-current-payment',
    templateUrl: './current-payment.component.html',
    styleUrls: ['./current-payment.component.scss']
})
export class CurrentPaymentComponent implements OnInit {

    @Input() paymentType = '';
    @Input() userSubscriptionDetails: any;
    @Input() userInfo: any;
    @Input() tenderInfo: any = {};
    @Input() isFPTenderAvailable;
    imgUrl: string;
    public scene7PresetDefaulImage = '&defaultImage=Not_Available';
    public scene7PresetCCIcon = '?$ccicon$';
    @Input() currentEnvironment;
    cardErrorMessage;
    properties = properties;

    enableForUPlus: boolean = this.properties.featureFlags.enableForUPlus;
    programDisplayData = this.enableForUPlus ? this.properties.programType.forUPlus : this.properties.programType.freshpass;

    constructor(
        private router: Router
    ) {
    }


    ngOnInit(): void {
        this.loadIcons();
        if (this.isFPTenderAvailable && this.tenderInfo) {
            if (this.tenderInfo.cardExpired) {
                this.cardErrorMessage = this.programDisplayData?.manage?.EXPIRED;
            } else if (this.tenderInfo.displayCVV) {
                this.cardErrorMessage = this.programDisplayData?.manage?.CONFIRM_CVV;
            }
        }
    }

    loadIcons() {
        if (this.isFPTenderAvailable && this.tenderInfo.cardType) {
            this.tenderInfo.ccIcon = 'https://images.albertsons-media.com/is/image/ABS/' + 'sub_' + this.tenderInfo.cardType.toLowerCase() + '_icon' + this.scene7PresetCCIcon + this.scene7PresetDefaulImage;
        }
    }

    goToPaymentMethods() {
        this.router.navigate([this.programDisplayData?.urlPath?.UPDATE_PAYMENT_PATH]);
    }
}
